'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _connectConfigure = require('../connectors/connectConfigure');

var _connectConfigure2 = _interopRequireDefault(_connectConfigure);

var _Configure = require('../components/Configure');

var _Configure2 = _interopRequireDefault(_Configure);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Configure is a non displayable widget that lets you provide parameters
 * for the Algolia queries.
 *
 * Any of the props added to this widget will be forwarded to Algolia. For more information
 * on the different parameters that can be set, have a look at the
 * [reference](https://www.algolia.com/doc/api-client/javascript/search#search-parameters).
 *
 * This widget can be used either with react-dom and react-native.
 * @name Configure
 * @kind widget
 * @example
 * import React from 'react';
 *
 * import {Configure} from '../packages/react-instantsearch/dom';
 *
 * export default function App() {
 *   return (
 *     <InstantSearch
 *       className="container-fluid"
 *       appId="latency"
 *       apiKey="6be0576ff61c053d5f9a3225e2a90f76"
 *       indexName="ikea"
 *     >
 *       <Configure distinct={1} />
 *     </InstantSearch>
 *   );
 * }
 */
var _default = (0, _connectConfigure2.default)(_Configure2.default);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/widgets/Configure.js');
}();

;


//////////////////
// WEBPACK FOOTER
// /tmp/~/react-instantsearch/src/widgets/Configure.js
// module id = 1184
// module chunks = 0